import * as React from 'react';

import Dropzone from 'react-dropzone';
import ProgressUploaderComponent from '../../shared/components/progress-uploader.component';
import { ILogoProcessingResult } from '../../logo-app/logo-upload/logo-upload.component';
import { DebuggerInstance } from '../../shared/debugger';
import { LogoClearMethod } from 'src/App/shared/logo.types';


export enum UploadState {
    NotStarted,
    Uploading,
    UploadFailed,
    UploadCompleted
}

export interface IDtpStepUploadProps {
    logoId: string;
    hash: string;
    apiUrl: string;
    onUploadCompleted(sucess: boolean, data: ILogoProcessingResult | null, message: string | null): void;
    onBackClick(): void;
}

export interface IDtpUploadState {
    uploadState: UploadState;
    uploadMessage?: string;
}

class DtpStepUploadComponent extends React.PureComponent<IDtpStepUploadProps,IDtpUploadState>{
    private uploader: ProgressUploaderComponent<ILogoProcessingResult> | null;

    constructor(props: IDtpStepUploadProps) {
        super(props);

        this.state = {
            uploadState: UploadState.NotStarted
        };
    }

    private onDropFiles(accepted: File[]): void {
        if (accepted.length === 0) {
            return;
        }

        if (this.uploader === null) {
            DebuggerInstance.error('App is not in valid state! Uploader component is missing!');
            return;
        }

        const file = accepted[0]; // je ocekavany pouze jeden soubor

        // kontrola typu souboru podle koncovky
        const ext = file.name.split('.').pop();
        if(ext !== 'png') {
            this.setState({
                uploadMessage: `Invalid file format: ${ext || 'unknown'}, only PNG is allowed.`
            })
            return;
        }

        if (this.uploader) {
            this.setState({
                uploadState: UploadState.Uploading
            });

            const apiUrl: string = this.props.apiUrl + 'reupload/' + this.props.logoId + '/' + this.props.hash;
            this.uploader.startUpload(file, apiUrl, LogoClearMethod.None);
        } else {
            DebuggerInstance.error('App is not in valid state! Uploader component is missing!');
        }
    }

    public render() {
        const disableControls: boolean = this.state.uploadState === UploadState.Uploading;

        return (
            <div className={'dtp-portal-card'}>
                <div className="title">
                    <span>Step: Upload corrected logo</span>
                </div>
                <div className="content">
                    <div className="dpt-upload-root">
                        <div className="upload-requirements">
                            <span>Please make sure that corrected logo meets this requirements:</span>
                            <ul>
                                <li>PNG format</li>
                                <li>Transparent colors</li>
                                <li>CMYK colors</li>
                            </ul>
                        </div>
                        <div className="drop-zone-container"
                            style={{ display: this.state.uploadState === UploadState.NotStarted ? 'block' : 'none' }}
                        >
                            <Dropzone
                                disabled={disableControls}
                                disabledStyle={{ opacity: 0.8 }}
                                className="drop-zone"
                                activeClassName="drop-zone-active"
                                onDrop={(accepted) => this.onDropFiles(accepted)}>
                                <p className="p-5"><span className="link-style">Click to browse</span> or Drag&amp;Drop logo file to start upload.</p>
                            </Dropzone>
                            {this.state.uploadMessage &&
                                <div className="upload-msg">{this.state.uploadMessage}</div>
                            }
                        </div>
                        <div className="upload-status-container"
                            style={{ display: this.state.uploadState !== UploadState.NotStarted ? 'block' : 'none' }}
                        >
                            <ProgressUploaderComponent<ILogoProcessingResult>
                                ref={(e) => { this.uploader = e }}
                                onUploadCompleted={(succ, data, err) => {
                                    this.setState({
                                        uploadState: succ ? UploadState.UploadCompleted : UploadState.UploadFailed
                                    });
                                    this.props.onUploadCompleted(succ, data, err)
                                }}
                                onRepeatUpload={() => DebuggerInstance.error('not implemented')}
                            />
                        </div>
                        <div className="actions" style={{ display: this.state.uploadState === UploadState.NotStarted ? 'flex' : 'none' }}>
                            <button className="action-continue"
                                onClick={() => this.props.onBackClick()}>Back</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export const DtpStepUpload = (props: IDtpStepUploadProps) => <DtpStepUploadComponent {...props} />



// WEBPACK FOOTER //
// ./src/App/dtp-portal/cards/dpt-step-upload.component.tsx